export const RoutePath = {
    DEFAULT: '/',
    LOGIN: '/login',
    REGISTRATION: '/registration',
    ACCOUNT_VERIFICATION: '/account-verification',
    FORGOT_PASSWORD: '/forgot-password',
    FORGOT_PASSWORD_CHANGING: '/forgot-password-changing',

    AFFILIATES: '/affiliates',
    REPORTS: '/reports',
    WITHDRAW: '/withdraw',
    DOMAINS: '/domains',
    USERS: '/users',
    PLAYERS: '/players',
    ACCOUNT: '/account',
    DESIGNS: '/designs',
    SIGNUPS: '/signups'
};

export const RestPath = {
    // Account verification
    VERIFY_EMAIL: '/Account/VerifyEmail',
    RESEND_EMAIL_VERIFICATION: '/Account/ResendEmailVerification/',
    VERIFY_MOBILE: '/Account/VerifyMobile',
    RESEND_MOBILE_VERIFICATION: '/Account/ResendMobileVerification',

    //Profile
    RECOVER_PASSWORD: '/api/Account/RecoverPassword',
    SEND_VERIFYCATION_EMAIL: '/User/SendEmailVerification',
    VERIFY_CHANGED_EMAIL: '/User/VerifyEmail',
    SEND_VERIFYCATION_MOBILE: '/User/SendMobileVerification',
    VERIFY_CHANGED_MOBILE: '/User/VerifyMobile',

    FORGOT_PASSWORD: '/api/Account/ForgotPassword',
    CHANGE_PASSWORD: '/api/Account/ChangePassword',
    CHANGE_MOBILE: '/User/ChangeMobile',
    CHANGE_FULLNAME: '/User/EditAccount',

    //Registration Controls
    MOVE_FORM_CONTROL: '/UICustomization/MoveFormItem',
    EDIT_FORM_ITEM: '/UICustomization/EditFormItem',
    CHANGE_CONTROL_WIZARD_STATE: '/UICustomization/ChangeWizard',
    CHECK_COMPANY_NAME: '/Account/CheckCompanyName',

    // Affiliates
    CREATE_AFFILIATE: '/api/Affiliate/Create',
    DELETE_AFFILIATE: '/api/Affiliate/Delete',
    GET_AFFILIATES: '/api/Affiliate/GetAffiliatesWithBalance',
    GET_PROJECT_ID: '/api/Affiliate/GetProjectId',
    GET_AFFILIATES_INFO: '/api/Info/GetAffiliates',
    GET_WITHDRAWAL_TYPES: '/api/Info/GetWithdrawalTypes',
    CHANGE_AFFILIATE_STATUS: '/api/Affiliate/ChangeStatus',
    GET_PERMISSIONS: '/api/Affiliate/GetPermissions',
    UPDATE_PERMISSIONS: '/api/Affiliate/UpdatePermissions',
    GET_COMMISSIONS: '/api/Affiliate/GetCommissions',
    UPDATE_COMMISSIONS: '/api/Affiliate/UpdateCommissions',
    GET_USER_ALLOWED_AFFILIATES: '/api/Info/GetUserAllowedAffiliates',
    // GET_DESIGN: '/api/Design/GetRedirectUrl',

    // Reports
    GET_PAYMENT_REPORT: '/api/Report/GetCalculatedReportForSubAffiliate',
    GET_REPORT_PAYMENTS: '/api/Info/GetSubAffiliateReportOperationTypes',
    GET_REPORT_FOR_AFFILIATE: '/api/Report/GetCalculatedReportForAffiliate',
    GET_REPORT_OPERATION_TYPE: '/api/Info/GetAffiliateReportOperationTypes',

    // Domains
    DOMAIN_CREATE: '/api/Domain/Create',
    DOMAIN_SET_STATUS: '/api/Domain/SetStatus',
    DOMAIN_GET_FOR_AFFILIATE: '/api/Domain/GetDomainsForAffiliate',
    DOMAIN_GET_FOR_SUBAFFILIATE: '/api/Domain/GetDomainsForSubAffiliate',
    DELETE_DOMAIN: '/api/Domain/Remove',
    ACTIVATION_CHECK: '/api/Domain/ActivationCheck',

    // Users
    GET_ALL_USERS: '/api/User/GetAllByFilter',
    GET_USER: '/api/User/GET',
    ADD_USER: '/api/User/Create',
    DELETE_USER: '/api/User/Remove',
    GET_USER_TYPES: '/api/Info/GetUserTypes',
    GET_USER_ALLOWED_PARTNER: '/api/Info/GetUserAllowedPartners',
    EDIT_USER: '/api/User/Update',

    // Language
    GET_LANGUAGES: '/api/Info/GetLanguages',

    // Cureencies
    GET_CURRENCIES: '/api/Info/GetCurrencies',

    // Players
    GET_PLAYERS: '/api/Player/GetAll',
    GET_PLAYER_BALANCE: '/api/Affiliate/GetBalance',
    TOPUP_PLAYER: '/api/Player/TopUp',

    // Sign Ups
    GET_SIGN_UPS: '/api/UserOrder/GetAll',
    DELETE_SIGN_UPS: '/api/UserOrder/Remove',

    // Withdraw
    GET_WITHDRAW: '/api/Withdrawal/GetWithdrawalsForAffiliate',
    GET_WITHDRAW_DETAILS: '/api/Withdrawal/GetDetails',
    UPDATE_WITHDRAW: '/api/Withdrawal/ChangeStatus',
    GET_SUB_WITHDRAW: '/api/Withdrawal/GetWithdrawalsForSubAffiliate',
    CREATE_WITHDRAW: '/api/Withdrawal/CreateWithdrawalRequest',
    CREATE_ADVANCE_WITHDRAW: '/api/Withdrawal/AdvanceWithdrawal',
    GET_WITHDRAWABLE_BALANCE: '/api/Withdrawal/GetWithdrawableBalance',
};


// WEBPACK FOOTER //
// ./src/constants/SitePaths.js